import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import { Helmet } from 'react-helmet-async'
import { useSearchParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { AccountSummary } from './AccountSummary'
import { PurchaseHistory } from './PurchaseHistory'

export const PointDetails = ({
  title,
  useGetPoint,
  backLink,
  accountSummary = [],
  purchaseHistory = [],
}) => {
  const [searchParams] = useSearchParams()

  const idParams = searchParams.get('id')

  const { data = [], isLoading } = useGetPoint({ customerId: idParams })

  return (
    <>
      <Helmet titleTemplate='%s | Point System' defaultTitle='Point System'>
        <title>{title}</title>
      </Helmet>
      <Navbar />
      <Box
        display='flex'
        justifyContent='space-between'
        flexDirection='row'
        px={{ xs: 3, md: 8 }}
        pt={3}
      >
        <Typography variant='h1'>Order History</Typography>
        <Button variant='outlined' component={Link} to={`/${backLink}`}>
          Back
        </Button>
      </Box>
      <Box pt={5} pb={10} px={{ xs: 3, sm: 5, md: 10 }}>
        <AccountSummary data={data[0]} isLoading={isLoading} additionalInfo={accountSummary} />
        <PurchaseHistory data={data} isLoading={isLoading} additionalInfo={purchaseHistory} />
      </Box>
    </>
  )
}
